import {Grid, Typography} from '@mui/material';
import LandingCta from '../landing/LandingCta';
import PricingFAQ from './PricingFAQ';
import PricingPlans from './PricingPlans';

const pricingPageContent = [PricingPlans, PricingFAQ];

export default function PricingPage() {
  return (
    <Grid container direction="column" spacing={2}>
      <Typography variant="h1" component="h1" gutterBottom align="center">
        Pricing
      </Typography>
      <Typography variant="h5" component="h2" gutterBottom align="center" color="text.secondary" sx={{mb: 6}}>
        Choose the perfect plan for your Etsy business
      </Typography>
      <Grid container spacing={8} direction="column" alignItems="center">
        {pricingPageContent.map((Component) => (
          <Grid key={`PricingPage-${Component.name}`} sx={{width: '100%'}}>
            <Component />
          </Grid>
        ))}
      </Grid>
      <LandingCta />
    </Grid>
  );
}
